import React from 'react';
import {Link} from 'react-router-dom';
import { push } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Markdown from 'react-markdown';

import styles from './styles.module.css';

import ServiceCard from '../../shared/components/ServiceCard';
import SectionTitle from '../../shared/components/SectionTitle';
import { isLoadingServicesList, getServicesList } from '../../shared/state/services/selectors';
import { getEditorialData } from '../../shared/state/editorial/selectors';

import animationImage from './animation.png';
import colorLogo from '../../assets/images/logo-solmar.png';
import WaveAnimated from '../../shared/components/WaveAnimated';

const Home = ({
    servicesList = [],
    editorialData: {companyShortDescription, homeHeaderImage: {url: photoUrl} = {}}
}) => (
    <div className={styles.main}>
        <div className={styles.homeHeader}
            style={{backgroundImage: `url('${photoUrl}')`}}>

            <div className={styles.title}>
                <img src={colorLogo}/>
            </div>
            
            <div className={styles.subtitle}>
                {'Limpezas e Produtos de Higiene'}
            </div>

            <WaveAnimated/>
        </div>
        <div className={styles.aboutSectionWrapper}>
            <SectionTitle 
                title={'Quem Somos'}
                center={true}/>

            <div className={styles.aboutSection}>

                <div className={styles.aboutSectionContent}>
                    <Markdown source={companyShortDescription}/>    
                </div>

                <div className={styles.aboutSectionLogo}>
                    <img src={animationImage}/> 
                </div>

            </div>
            
            <div className={styles.viewMoreServices}>
                <Link className={styles.viewMoreServices} to={'/quem-somos'}>
                    {'Saiba mais sobre nós...'}
                </Link>    
            </div>

        </div>
        <div className={styles.services}>
            <SectionTitle 
                center={true}
                title={'Serviços'}
                subTitle={'Oferecemos solução para vários tipos de serviços'}/>
            <div className={styles.servicesList}>
                {
                    servicesList.slice(0,3).map(service => (
                        <ServiceCard 
                            key={service.id}
                            service={service}/>
                    ))
                }
            </div>
            <div className={styles.viewMoreServices}>
                {
                    servicesList.length > 3 ? (
                        <Link className={styles.viewMoreServices} to={'/servicos'}>
                            {'Ver Mais Serviços'}
                        </Link>
                    ) : null
                }    
            </div>
        </div>
        
    </div>
);


const mapStateToProps = () => {
    return (state) => ({
        isLoadingServices: isLoadingServicesList(state),
        servicesList: getServicesList(state),
        editorialData: getEditorialData(state)
    });
};

export default connect(mapStateToProps)(Home);